import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { createSignal } from 'solid-js';

await i18next
  .use(HttpBackend)
  .use(LanguageDetector)
  .init({
    lng: 'zh',
    supportedLngs: ['en', 'zh'],
    fallbackLng: 'zh',
    // debug: true, // 开发时可以开启 debug 模式
    detection: {
      // 配置语言检测器
      order: ['localStorage', 'htmlTag'],
      caches: ['localStorage'], // 将检测到的语言缓存到 localStorage
      lookupLocalStorage: 'i18nextLng', // localStorage 中的 key
    },
    backend: {
      // 配置后端加载器
      loadPath: '/locales/{{lng}}/{{ns}}.json', // 语言文件加载路径
    },
    ns: ['translation'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false, // SolidJS/React 已经做了 XSS 防护
    },
  });

const [lang, setLang] = createSignal(i18next.language);

// 监听 i18next 的语言变化事件
i18next.on('languageChanged', (lng) => {
  setLang(lng); // 改变 signal，触发 UI 更新
});

// 返回一个响应式的 t()
export function useI18n() {
  return {
    t: (...args: Parameters<typeof i18next.t>) => {
      lang(); // 依赖 signal，保证切换时重新执行
      return i18next.t(...args);
    },
    lang,
    setLang: (lng: string) => i18next.changeLanguage(lng),
  };
}

export const i18n = i18next;
